import { render, staticRenderFns } from "./CustomRadioOn.vue?vue&type=template&id=a8c6bc4e&"
import script from "./CustomRadioOn.vue?vue&type=script&lang=ts&"
export * from "./CustomRadioOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports